import { useApplicationCapabilitiesAllowed } from "../../infra/application/capabilities/hooks/useApplicationCapabilitiesAllowed";
import { useMemo } from "react";
import useTranslatedCharacterFeature from "../localization/hooks/useTranslatedCharacterFeature";
import { FEATURE_FILTER_OPTIONS } from "./featureFilterOptions";
const featureOptionCapabilities = FEATURE_FILTER_OPTIONS.map(({ capability }) => capability);
export default function useAllowedFeatureFilterOptions() {
    const allowed = useApplicationCapabilitiesAllowed(featureOptionCapabilities);
    const { getFeatureLabel, getFeatureSubtitle } = useTranslatedCharacterFeature();
    return useMemo(() => FEATURE_FILTER_OPTIONS.flatMap((option, index) => (allowed[index] ? [option] : [])).map((option) => ({
        ...option,
        label: getFeatureLabel(option.value),
        subtitle: getFeatureSubtitle(option.value),
    })), [allowed, getFeatureLabel, getFeatureSubtitle]);
}
